export default {"src":"/fly/_next/static/media/pe.694f8313.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};